module.exports = {"data":{"site":{"siteMetadata":{"title":"Alex's Portfolio"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 103
// module chunks = 60335399758886 114276838955818